import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "timeline",
  class: "timeline"
}

import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import EpochJVM from "../epoch/EpochJVM.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineJVM',
  setup(__props) {

const store = useTimelineMapStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).epochs, (epoch) => {
      return (_openBlock(), _createBlock(EpochJVM, {
        key: epoch.id,
        epoch: epoch
      }, null, 8 /* PROPS */, ["epoch"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})